module.exports = __webpack_public_path__ + "c886af653b666cbd46232aca964b1ec6.png";